/* The mockup's `.crumb-name`: text until hovered or focused. */
.name {
  min-inline-size: 60px;
  max-inline-size: 260px;
  padding: 4px 6px;
  border: 1px solid transparent;
  border-radius: var(--radius-small);
  background: transparent;
  color: var(--text);
  font: inherit;
  font-size: var(--font-size-13);
  font-weight: var(--font-weight-medium);
  text-overflow: ellipsis;
}

.name:hover {
  border-color: var(--border-control);
}

/* The measured 2px ring (D-UX-5) with the mockup's halo. */
.name:focus-visible {
  outline: 2px solid var(--focus-ring);
  outline-offset: -1px;
  box-shadow: 0 0 0 3px var(--action-soft);
}

.text {
  overflow: hidden;
  max-inline-size: 260px;
  color: var(--text);
  font-size: var(--font-size-13);
  font-weight: var(--font-weight-medium);
  text-overflow: ellipsis;
  white-space: nowrap;
}
